import { Box, Button, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { useAppBar } from '../../../../../components/appBar/appBarContext';
import CheckboxCard from '../../../../../components/card/CheckboxCards/checkboxCard';
import ElementTitle from '../../../../../components/title/elementTitle/elementTitle';
import { changeRouteType, getpervInnerState } from '../../../../../redux/handleBackBtn/handleBackBtnSlice';
import { RootState } from '../../../../../redux/store';
import { PayInstallmentsPayment } from '../../../../../services/payment.service';
import { IContainerApp } from '../../containerApp/IContainerApp';



const FutureLoans = ({ referenceKey, setStep }: IContainerApp) => {

    const [totalAmount, setTotalAmuont] = useState<number>(0)
    const [itemAmounts, setItemAmounts] = useState<{
        index: number,
        amount: number,
        isChecked: boolean,
        key: string
    }[]>([])
    const dispatch = useDispatch()
    const notSetteldList = useSelector((state: RootState) => state.notSetteled)
    const [checkList, setCheckList] = useState<boolean[]>(notSetteldList.map(() => false))

    const { setHeader } = useAppBar();


    const handleChangeLoansList = (
        index: number,
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        const checked = e.target.checked;

        const updatedItems = itemAmounts.map((item, i) => {
            const isTargetChecked = checked ? i <= index : i < index;
            return {
                ...item,
                isChecked: isTargetChecked,
                amount: isTargetChecked ? notSetteldList[i].amount + notSetteldList[i].penaltyAmount : 0
            };
        });

        setItemAmounts(updatedItems);

        const total = updatedItems
            .filter(it => it.isChecked)
            .reduce((sum, it) => sum + it.amount, 0);
        setTotalAmuont(total);
    };


    useEffect(() => {
        setHeader('پرداخت اقساط', 'loans')
        dispatch(changeRouteType({ routeType: 'child' }));
        dispatch(getpervInnerState({ prevInnerState: 'AssignedLoans' }));
    }, [])

    useEffect(() => {
        if (!notSetteldList) return;

        const initial = notSetteldList.map((item, index) => ({
            index,
            amount: item.amount + item.penaltyAmount,
            isChecked: item.penaltyAmount > 0,
            key: item.key,
            penalty: item.penaltyAmount
        }));

        setItemAmounts(initial);
        const initialTotal = initial
            .filter(it => it.isChecked)
            .reduce((sum, it) => sum + it.amount, 0);
        setTotalAmuont(initialTotal);
    }, [notSetteldList]);


    useEffect(() => {
        setCheckList(itemAmounts.map(x => x.isChecked))
    }, [itemAmounts])

    const { mutateAsync: PayInstallmentsPaymentMutate } = useMutation(
        PayInstallmentsPayment,
        {
            onSuccess: (data) => {
                if (data?.redirectionToBankUrl) {

                    window.location.href = data.redirectionToBankUrl;

                    // window.open(data.redirectionToBankUrl, '_blank');
                } else {
                    console.error("Bank URL not found in response");
                }
            },
            onError: (error) => {
                console.error("Payment failed", error);
            }

        });
    const handleInstalmentPayment = () => {
        const callBack = window.location.origin;

        const selectedItems = itemAmounts.filter((item) => item.isChecked)
        PayInstallmentsPaymentMutate({ referenceKey: referenceKey!, keys: selectedItems.map(x => x.key), callBack });
    }

    return (
        <div className='h-full'>
            <Grid className='relative' sx={{ overflowY: "auto", height: "100%" }} gap={'2rem'} container flexDirection={"column"}>
                <Grid item sx={{ overflowY: "auto", marginBottom: "50px" }}>
                    <div className='mb-2'>
                        <ElementTitle title='اقساط  پرداخت نشده' />
                    </div>
                    {notSetteldList.map((item, index) => (
                        <Box sx={{ marginBottom: "10px" }}>
                            <CheckboxCard
                                // cheked={itemAmounts[index]?.isChecked}
                                cheked={checkList[index]}
                                disable={index > 0 && !itemAmounts[index - 1]?.isChecked}
                                onChange={(e) => handleChangeLoansList(index, e)}
                                checkboxTitle={`${item?.amount.toLocaleString()} ریال`}
                                checkboxTitleDetail={item?.penaltyAmount ? item?.penaltyAmount : 0}
                                moreDetail={item?.dueDatePersian}
                                key={index}
                                installmentNo={item.installmentNo}
                            />
                        </Box>
                    ))}
                </Grid>

                <Grid item sx={{
                    position: "absolute", width: "100%", maxWidth: "900px", bottom: "10px"
                }} >
                    <Button
                        fullWidth
                        onClick={() => handleInstalmentPayment()}
                        disabled={itemAmounts.every(x => !x.isChecked)}
                        sx={{

                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center", height: "42px",
                            paddingInline: "1rem",
                            backgroundColor: 'var(--button-color) !important',
                            color: 'var(--bg-color) !important',
                            opacity: itemAmounts.every(x => !x.isChecked) ? 0.4 : 1
                        }}>
                        <Typography marginX={"8px"} >
                            پرداخت مبلغ
                        </Typography>
                        <Typography sx={{ fontSize: "0.95rem" }}>
                            <span style={{ fontWeight: 'bold' }}>{totalAmount?.toLocaleString('fa')}</span> ریال
                        </Typography>
                    </Button>
                </Grid>

            </Grid>
        </div>
    )
}


export default FutureLoans